// BM-7639 — Persist ticked column-total scopes per (range plan × user) in localStorage.
// Storage shape:  rangeplan_totals_${rangeplanId}_${userId}  →  { [columnId]: ['all','active',...] }
// Reads are defensive: if a key is missing or the JSON is malformed, we return an empty map.

import { localStorageService } from '../../../../services/localStorage.service';

const SUPPORTED_SCOPES = ['all', 'selected'];

const buildKey = (rangeplanId, userId) => `rangeplan_totals_${rangeplanId}_${userId}`;

export const loadColumnScopes = (rangeplanId, userId) => {
  if (!rangeplanId || !userId) return {};
  try {
    const raw = localStorageService.get(buildKey(rangeplanId, userId));
    if (!raw || typeof raw !== 'object') return {};
    // Strip anything that isn't a known scope so a corrupted entry can't break the reducer.
    const cleaned = {};
    for (const [columnId, scopes] of Object.entries(raw)) {
      if (!Array.isArray(scopes)) continue;
      const valid = scopes.filter((s) => SUPPORTED_SCOPES.includes(s));
      if (valid.length > 0) cleaned[columnId] = valid;
    }
    return cleaned;
  } catch (_e) {
    return {};
  }
};

export const saveColumnScopes = (rangeplanId, userId, columnId, scopes) => {
  if (!rangeplanId || !userId || !columnId) return;
  const existing = loadColumnScopes(rangeplanId, userId);
  const validScopes = Array.isArray(scopes) ? scopes.filter((s) => SUPPORTED_SCOPES.includes(s)) : [];
  if (validScopes.length === 0) {
    delete existing[columnId];
  } else {
    existing[columnId] = validScopes;
  }
  localStorageService.set(buildKey(rangeplanId, userId), existing);
};
